import { useState } from "#app";
import { ref, computed } from "vue";
export const useUIState = (stateName) => {
  let state;
  if (stateName) {
    state = useState(stateName, () => false);
  } else {
    state = ref(false);
  }
  const isOpen = computed(() => state.value);
  const switchState = (to) => {
    state.value = typeof to === "undefined" ? !state.value : !!to;
  };
  return {
    isOpen,
    switchState
  };
};
